import { render } from "preact";
import App from "@/app.tsx";
import "@/index.css";

const appDiv = document.getElementById("learning-compass");

if (appDiv) {
  render(<App />, appDiv);
}
